import {isViewMode} from "../../../../../configs/view_only";

export class Local implements ServerConnectionInterface {
  private eventCallbacks: Map<string, Function[]> = new Map<string, Function[]>();
  private objectCounter = 0;

  connect() {
    setTimeout(() => {
      this.dispatchEvent('connect');
    }, 0);
  }

  on(event: string, callback: Function) {
    if (isViewMode) {
      return;
    }
    if (!this.eventCallbacks.has(event)) {
      this.eventCallbacks.set(event, []);
    }
    this.eventCallbacks.get(event).push(callback);
  }

  onAction(event: string, callback: Function) {
    if (!this.eventCallbacks.has(event)) {
      this.eventCallbacks.set(event, []);
    }
    this.eventCallbacks.get(event).push(callback);
  }

  getUsers() {
    return new Map<string, object>();
  }

  emit(event, data, callback, silent) {
    if (isViewMode) {
      return;
    }
    if (!silent) {
      this.beforeRequest();
    }
    if (location.search.indexOf('debug_socketio=1') >= 0) {
      console.log('=> SOCKETIO:', event, data);
    }
    return new Promise((resolve, reject) => {
      if (!silent) {
        this.afterRequest();
      }
      let response = null;
      switch (event) {
        case 'addObject':
          response = data;
          response.id = ++this.objectCounter;
          break;
        case 'updateObject':
          response = data;
          break;
        case 'removeObject':
          response = true;
          break;
        case 'mousePosition':
          response = true;
          break;
        default:
          console.log(event, data);
          throw new Error('Can\'t process event ' + event);
      }
      if (callback) {
        callback.apply(null, [response]);
      }
      resolve.apply(null, [response]);
    });
  }

  getSocket() {
    return {connected: true};
  }

  beforeRequest() {
    this.dispatchEvent('__beforeRequest');
  }

  afterRequest() {
    this.dispatchEvent('__afterRequest');
  }

  dispatchEvent(event: string, data?: any) {
    if (this.eventCallbacks.has(event)) {
      this.eventCallbacks.get(event).forEach((cb) => cb.apply(null, data));
    }
  }
}
